// GET DATA UPCOMING EVENT
export const GET_CATEGORY_EVENT_REQUEST = 'GET_CATEGORY_EVENT_REQUEST'
export const GET_CATEGORY_EVENT_FAILED = 'GET_CATEGORY_EVENT_FAILED'
export const GET_CATEGORY_EVENT_SUCCESS = 'GET_CATEGORY_EVENT_SUCCESS'
export const GET_KOTA_VENUE_SUCCESS = 'GET_KOTA_VENUE_SUCCESS'
export const CHANGE_COLOR_SUCCESS = 'GET_KOTA_VENUE_SUCCESS'


